import React, { useState, useEffect } from "react";
import "../../styles/MenuItems.css"
import "../../styles/Styles.css";

function Alcohols() {

    const [alcohols, setAlcohols] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'ALKOHOLE');

            if (category) {
                setAlcohols(category.menu_items);
            };
        });
    }, []);

    return(
        <div className="container-fluid section-cream-background">
                <div className="container section-menu-item">
                    <div className="menu-left-70">
                    <div className="menu-item-title-section d-flex justify-content-between align-items-end">
                <p className="menu-item-title-font fs-1 m-0 fw-bold">ALKOHOLE</p>
                <p className="fs-5 mb-1 fw-light">40 / 700ml</p>
                </div>
                <hr/>
                {alcohols.map((alcohol) => (
                    <div key={alcohol.id} className="container">
                        <div className="dish-name-container d-flex justify-content-between">
                            <p className="menu-item-title-font fs-5 m-0">{alcohol.name}</p>
                            <p className="fs-5 m-0">{alcohol.price}zł</p>
                        </div>
                        <p className="ingridients-container fs-6 m-0 fw-lighter">{alcohol.ingredients}</p>
                        <div className="mb-3 mt-3 divide-line"/>
                    </div>
                ))}
                </div>
                <div className="dish-photo-right-container-25 photo-height-alcohols">
                    <img src={require("../../assets/menu/alcohol.webp")} className="dish-photo-soups img-menu img-rounded shadow" />
                </div>
            </div>
        </div>
    )
}

export default Alcohols;